<template>
    <div class="loader">
        <div class='loader loader-circle basic-stretchy'>
            <div class='spinner spinner-shape-1'></div>
        </div>
    </div>
</template>

<style lang="scss" src="@/assets/scss/views/Spinner.scss"></style>